import React from 'react';

export default class Hero extends React.Component {
  render() {
    return (
      <>
        <div class="w-full flex h-screen pt-24 pb-12 px-6 lg:px-32" >
          <div class="m-auto text-white">
            <h1 class="font-semibold">
              <span class="text-white text-4xl sm:text-7xl sm:leading-tight">ビジュアルデータで<br class="hidden sm:block" />読み解く江戸時代</span><br />
            </h1>
            <p class="mt-4 mb-12 sm:pt-12 font-semibold text-2xl sm:text-5xl sm:leading-snug text-left sm:text-right text-yellow-400">天下泰平の世は<br class="hidden sm:block" />なぜ260年続いたか</p>
            <p>全国諸大名のデータをもとに、戦国時代から江戸時代にかけての日本の「実像」に迫ります。</p>
            <div class="mt-12 border rounded-xl p-4 text-center">
              画面幅の小さいデバイスでの表示には、近日中に対応いたします。
            </div>
          </div>
        </div>
      </>
    )
  }
}